import Immutable from 'immutable';

const SPORT_KEYS = 'sports';
const LEAGUE_KEYS = 'leagues';
const MATCH_KEYS = 'matches';
const SCORE_KEYS = 'scores';
const OUTCOME_KEYS = 'outcomes';
const RATE_KEYS = 'rates';

const repository = Immutable.fromJS(
    {
        [SPORT_KEYS]: {},
        [LEAGUE_KEYS]: {},
        [MATCH_KEYS]: {},
        [SCORE_KEYS]: {},
        [OUTCOME_KEYS]: {},
        [RATE_KEYS]: {}
    }
);

export default class ImmutableRepository {
    constructor() {
        this._repo = repository;
    }

    addSport(id) {
        let key = {id};
        this._repo = this._repo.setIn([SPORT_KEYS, id], key);
        return key;
    }

    getSportKey(id) {
        return this._repo.getIn([SPORT_KEYS, id]);
    }

    removeSport(id) {
        this._repo = this._repo.deleteIn([SPORT_KEYS, id]);

        const leagues = this._repo.get(LEAGUE_KEYS).filter((l) => l.sportId === id).map(l => l.id).toArray();

        for (let i = 0; i < leagues.length; i++) {
            this.removeLeague(leagues[i]);
        }
    }

    addLeague(sportId, leagueId) {
        const key = {
            sportId,
            id: leagueId
        };

        this._repo = this._repo.setIn([LEAGUE_KEYS, leagueId], key);

        return key;
    }

    getLeagueKey(id) {
        return this._repo.getIn([LEAGUE_KEYS, id]);
    }

    removeLeague(leagueId) {
        const key = this._repo.getIn([LEAGUE_KEYS, leagueId]);

        this._repo = this._repo.deleteIn([LEAGUE_KEYS, leagueId]);

        const matches = this._repo.get(MATCH_KEYS).filter((m) => m.leagueId === leagueId).map(l => l.id).toArray();

        for (let i = 0; i < matches.length; i++) {
            this.removeMatch(matches[i]);
        }

        return key;
    }

    addMatch(leagueId, matchId) {
        const leagueKey = this._repo.getIn([LEAGUE_KEYS, leagueId]);

        const key = {
            sportId: leagueKey.sportId,
            leagueId,
            id: matchId
        };

        this._repo = this._repo.setIn([MATCH_KEYS, matchId], key);

        return key;
    }

    getMatchKey(id) {
        return this._repo.getIn([MATCH_KEYS, id]);
    }

    removeMatch(matchId) {
        const key = this._repo.getIn([MATCH_KEYS, matchId]);

        this._repo = this._repo.deleteIn([MATCH_KEYS, matchId]);

        const scores = this._repo.get(SCORE_KEYS).filter((s) => s.matchId === matchId).map(s => s.id).toArray();

        for (let i = 0; i < scores.length; i++) {
            this.removeScore(scores[i]);
        }

        const outcomes = this._repo.get(OUTCOME_KEYS).filter((o) => o.matchId === matchId).map(o => o.id).toArray();

        for (let i = 0; i < outcomes.length; i++) {
            this.removeOutcome(outcomes[i]);
        }

        return key;
    }

    addScore(matchId, scoreId) {
        const matchKey = this._repo.getIn([MATCH_KEYS, matchId]);

        const key = {
            sportId: matchKey.sportId,
            leagueId: matchKey.leagueId,
            matchId: matchKey.id,
            id: scoreId
        };

        this._repo = this._repo.setIn([SCORE_KEYS, scoreId], key);

        return key;
    }

    getScoreKey(id) {
        return this._repo.getIn([SCORE_KEYS, id]);
    }

    removeScore(scoreId) {
        const key = this._repo.getIn([SCORE_KEYS, scoreId]);

        this._repo = this._repo.deleteIn([SCORE_KEYS, scoreId]);

        return key;
    }

    addOutcome(matchId, outcomeId) {
        const matchKey = this._repo.getIn([MATCH_KEYS, matchId]);

        const key = {
            sportId: matchKey.sportId,
            leagueId: matchKey.leagueId,
            matchId: matchKey.id,
            id: outcomeId
        };

        this._repo = this._repo.setIn([OUTCOME_KEYS, outcomeId], key);

        return key;
    }

    getOutcomeKey(id) {
        return this._repo.getIn([OUTCOME_KEYS, id]);
    }

    removeOutcome(outcomeId) {
        const key = this._repo.getIn([OUTCOME_KEYS, outcomeId]);

        this._repo = this._repo.deleteIn([OUTCOME_KEYS, outcomeId]);

        const rates = this._repo.get(RATE_KEYS).filter((r) => r.outcomeId === outcomeId).map(r => r.id).toArray();

        for (let i = 0; i < rates.length; i++) {
            this.removeRate(rates[i]);
        }

        return key;
    }

    addRate(outcomeId, rateId) {
        const outcomeKey = this._repo.getIn([OUTCOME_KEYS, outcomeId]);

        const key = {
            sportId: outcomeKey.sportId,
            leagueId: outcomeKey.leagueId,
            matchId: outcomeKey.matchId,
            outcomeId: outcomeKey.id,
            id: rateId
        };

        this._repo = this._repo.setIn([RATE_KEYS, rateId], key);

        return key;
    }

    getRateKey(id) {
        return this._repo.getIn([RATE_KEYS, id]);
    }

    removeRate(rateId) {
        this._repo = this._repo.deleteIn([RATE_KEYS, rateId]);
    }
}



// WEBPACK FOOTER //
// ./js/repositories/ImmutableRepository.js